export default __webpack_public_path__ + "assets/images/34076502f6ef017a23689f979af8b2ec.png";